const STATUS = {
  rehab: { label: "In Rehab", color: "#D97706", bg: "#FEF3E2" },
  for_sale: { label: "For Sale", color: "#2563EB", bg: "#E8F0FE" },
  sold: { label: "Sold", color: "#2563EB", bg: "#E8F0FE" },
  rental: { label: "Retained Rental", color: "#059669", bg: "#E7F6EF" },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.rehab;
  return (
    <span
      data-testid={`status-${status}`}
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold"
      style={{ color: s.color, backgroundColor: s.bg }}
    >
      {s.label}
    </span>
  );
}

export { STATUS };
